import { createStyles, Paper, Theme, withStyles, WithStyles } from "@material-ui/core";
import classNames from "classnames";
import React, { PropsWithChildren } from "react";
import { HEIGHT_LOWER_THRESHOLD } from "../const";

const styles = (theme: Theme) =>
    createStyles({
        pollContainer: {
            overflow: "hidden",
            backgroundColor: theme.palette.grey[50],
            WebkitTapHighlightColor: "transparent",
        },
    });

type Props = WithStyles<typeof styles> &
    PropsWithChildren<{
        availableHeight?: number;
        isLastScreen?: boolean;
    }>;

class Component extends React.Component<Props> {
    render = () => {
        const { classes, children, availableHeight } = this.props;
        const ratio = (availableHeight || 0) < HEIGHT_LOWER_THRESHOLD ? 1.25 : 1.8;
        const availableWidth = availableHeight ? availableHeight / ratio : undefined;
        return (
            <Paper
                elevation={3}
                className={classNames(classes.pollContainer)}
                sx={{
                    height: availableHeight ? availableHeight - 16 : undefined, // top and bottom 8px spacing
                    width: availableWidth,
                    padding: 1,
                }}>
                {children}
            </Paper>
        );
    };
}

const PollContainer = withStyles(styles)(Component);

export default PollContainer;
